"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright 2024, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const SurveyParticipant_1 = __importDefault(require("../pages/SurveyParticipant"));
const ErrorBoundary_1 = __importDefault(require("../survey/ErrorBoundary"));
// FIXME Type the props
const SurveyWithErrorBoundary = (props) => (react_1.default.createElement(ErrorBoundary_1.default, null,
    react_1.default.createElement(SurveyParticipant_1.default, Object.assign({}, props))));
exports.default = SurveyWithErrorBoundary;
//# sourceMappingURL=SurveyWithErrorBoundary.js.map